/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ARGOS_WARNING} from "../../../constants/colors";
import Button from "react-bootstrap/Button";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, IconButton, Typography,} from '@mui/material';
import ArgosButton from "../Buttons/ArgosButton";
import ArgosFlexbox from "../Containers/ArgosFlexbox";
import { StyledArgosDialog } from "../Dialogs/ArgosDialog";
import ArgosDialogHeader from "../Dialogs/ArgosDialogHeader";
import CloseIcon from '@mui/icons-material/Close';

interface ISubmitPopupProps {
  popBool: boolean
  setPopBool: React.Dispatch<React.SetStateAction<boolean>>
  handleSubmit: () => void
  didFileUploadFail: boolean
  sheetErrors: boolean
  fileDataHasErrors: boolean
  title: string
  contentText?: string,
}

export const SubmitWizardPopup = (props: ISubmitPopupProps) => {
  const {popBool, setPopBool, handleSubmit, didFileUploadFail, sheetErrors, fileDataHasErrors, title} = props
  const isDisabled = didFileUploadFail || sheetErrors || fileDataHasErrors
  const uploadFailWarning = 'Warning: File upload had errors'
  const sheetErrorsWarning = 'Warning: file had errors'
  return (
    <StyledArgosDialog width={"40vh"} height={"fit-content"} {...props} open={popBool} onClose={() => { }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <ArgosDialogHeader>
          <ArgosFlexbox style={{justifyContent: 'space-between', alignItems: 'center'}}>
            <Typography sx={{ color: 'white', fontSize: 14 }}>{props.title}</Typography>
            <IconButton onClick={() => {setPopBool(false)}} sx={{color: 'white', padding: 0, fontSize: 'small'}}> 
              <CloseIcon />
            </IconButton>
          </ArgosFlexbox>
        </ArgosDialogHeader>
      </div>
      {/* eslint-disable-next-line react/jsx-no-undef */}
      <DialogContent>
        {isDisabled && (
          <DialogContentText color={'error'}>
            <div style={{color: ARGOS_WARNING}}> {uploadFailWarning} </div>
            <div style={{color: ARGOS_WARNING}}> {sheetErrorsWarning} </div>
          </DialogContentText>
        )}
        {isDisabled ? (
          <DialogContentText color={'error'}>
            Submit disabled. Check for error messages in all steps.
          </DialogContentText>
        ) : (
          <DialogContentText color={'3FB9DB'}>
            {props?.contentText}
          </DialogContentText>
        )}
      </DialogContent>
      <Divider/>
      {/* eslint-disable-next-line react/jsx-no-undef */}
        <ArgosFlexbox style={{justifyContent: "center"}}>
          <DialogActions sx={{color: "#3FB9DB"}}>
            <ArgosButton 
              onClick={() => {
                setPopBool(false)
              }}>
              CANCEL
            </ArgosButton>
            <ArgosButton 
              onClick={handleSubmit} 
              disabled={isDisabled}>
              OK
            </ArgosButton>
          </DialogActions>
        </ArgosFlexbox>
    </StyledArgosDialog>
  )
}